import { render, staticRenderFns } from "./ProjectCostApplication.vue?vue&type=template&id=20d3e758&scoped=true"
import script from "./ProjectCostApplication.vue?vue&type=script&lang=js"
export * from "./ProjectCostApplication.vue?vue&type=script&lang=js"
import style0 from "./ProjectCostApplication.vue?vue&type=style&index=0&id=20d3e758&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d3e758",
  null
  
)

export default component.exports